import { css } from '@emotion/react';
import { Button, Divider, Heading, tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';
import { formatLongRules, ShortRule } from 'shared';

import { DisplayId } from '../modals';
import { BaggageShortRuleList, OrdinaryShortRules } from '../shortRules/ShortRules';

import { getShortRulesByCategory } from './helpers';
import { RuleCategory } from './types';

const styles = {
  wrapper: css`
    display: flex;
    gap: ${tokens.dimension['space-4']};
    flex-direction: column;
    width: 100%;
  `,
  container: css`
    border: 1px solid ${tokens.color.gray[80]};
    padding: ${tokens.dimension['space-7']};
    border-radius: ${tokens.dimension['space-4']};
  `,
  nonBaggageShortRules: css`
    padding-top: ${tokens.dimension['space-4']};
  `,
};

type Props = {
  longRules: string[];
  shortRules: ShortRule[];
  onClickHandler: (displayId: DisplayId) => () => void;
  ticketRulesDisplayId: DisplayId;
  isBoundsSelected?: boolean;
};

export const FareInformation = ({
  longRules,
  shortRules,
  ticketRulesDisplayId,
  isBoundsSelected = true,
  onClickHandler,
}: Props) => {
  const rebookRefundRules = getShortRulesByCategory(shortRules, RuleCategory.RefundAndRebook);
  const ordinaryRules = getShortRulesByCategory(shortRules, RuleCategory.Ordinary);
  const nonBaggageShortRules = rebookRefundRules.concat(ordinaryRules);

  return (
    <div css={styles.wrapper}>
      <div css={styles.container}>
        <Heading
          style={{ marginBottom: tokens.dimension['space-2'] }}
          size={'title-3'}
          color={'heading-primary'}
          as={'h5'}
        >
          {t('common:includedInTrip', { defaultValue: 'Included in your trip' })}
        </Heading>
        <BaggageShortRuleList largeFont={true} shortRules={getShortRulesByCategory(shortRules, RuleCategory.Baggage)} />
        <Divider variant="neutral" direction="horizontal" />
        <OrdinaryShortRules shortRules={nonBaggageShortRules} css={styles.nonBaggageShortRules} />
      </div>
      <div css={styles.container}>
        <span
          dangerouslySetInnerHTML={{
            __html: formatLongRules(longRules),
          }}
        />
      </div>

      {isBoundsSelected && (
        <div>
          <Button
            onClick={() => onClickHandler(ticketRulesDisplayId)()}
            variant={'link'}
            size={'small'}
            trailingIcon="Arrow"
            rotation={90}
          >
            {t('ticketRules', { defaultValue: 'Ticket rules' })}
          </Button>
        </div>
      )}
    </div>
  );
};
